export default (state = [], action) => {
   switch (action.type) {
       case 'FETCH_APPROVALS':
           return action.payload.approvals;
        case 'TASK_CLEARED':
            //remove ID task from approval list
            return state.filter(approval => approval.id !== action.payload.id);
        default:
            return state;
   }
};